(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["endurosip-bulk-orders"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('endurosip-bulk')) {
  customElements.define('endurosip-bulk', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.$ = (selector) => this.querySelector(selector);
      this.messages = this.$('[data-messages]').dataset;
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: 'USD' });
      this.integer = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { maximumFractionDigits: 0 });
      this.familySelect = this.$('[data-family-select]');
      this.sizeSelect = this.$('[data-size-select]');
      this.colorSelect = this.$('[data-color-select]');
      this.artworkSelect = this.$('[data-artwork-select]');
      this.otherProductField = this.$('[data-other-product-field]');
      this.otherProductInput = this.$('[data-other-product-input]');
      this.otherProductLabel = 'Other EnduroSip Product / Product Not Listed';
      this.range = this.$('[data-range]');
      this.number = this.$('[data-quantity]');
      this.cards = Array.from(this.querySelectorAll('[data-product-card]'));
      this.storageKey = `endurosip-bulk:${this.id}`;
      this.familySelect.replaceChildren(...[...new Set(this.cards.map(card => card.dataset.family))].map(family => this.option(family)), this.option(this.otherProductLabel));
      this.familySelect.addEventListener('change', () => {
        if (this.familySelect.value === this.otherProductLabel) {
          this.chooseOther();
          return;
        }
        const matches = this.cards.filter(card => card.dataset.family === this.familySelect.value);
        this.choose((matches.find(card => card.dataset.size === this.card.dataset.size) || matches[0]).dataset.id);
      });
      this.otherProductInput.addEventListener('input', () => this.render());
      this.sizeSelect.addEventListener('change', () => {
        const card = this.cards.find(card => card.dataset.family === this.familySelect.value && `${card.dataset.size} oz` === this.sizeSelect.value);
        if (card) this.choose(card.dataset.id);
      });
      this.colorSelect.addEventListener('change', () => { this.updateImage(); this.render(); });
      this.artworkSelect.addEventListener('change', () => { this.updateArtwork(); this.render(); });
      this.range.addEventListener('input', () => this.setQuantity(this.range.value));
      this.number.addEventListener('input', () => {
        if (this.number.validity.valid && this.number.value !== '') this.setQuantity(this.number.value);
      });
      this.number.addEventListener('change', () => this.setQuantity(this.number.value));
      this.$('[data-minus]').addEventListener('click', () => this.setQuantity(this.quantity - this.config.step));
      this.$('[data-plus]').addEventListener('click', () => this.setQuantity(this.quantity + this.config.step));
      this.$('[data-quote-link]').addEventListener('click', () => {
        requestAnimationFrame(() => this.$('[autocomplete="name"]').focus({ preventScroll: true }));
      });
      this.$('form').addEventListener('submit', () => { this.setQuantity(this.number.value); });
      let saved;
      try { saved = JSON.parse(sessionStorage.getItem(this.storageKey)); } catch (_) { saved = null; }
      const selected = saved && this.cards.some(card => card.dataset.id === saved.product) ? saved.product : this.cards[0].dataset.id;
      this.choose(selected, saved);
      this.updateArtwork();
      this.$('[data-builder]').hidden = false;
      this.$('[data-details]').hidden = false;
      const success = this.$('[data-form-success]');
      if (success) { success.focus(); try { sessionStorage.removeItem(this.storageKey); } catch (_) {} }
      this.addEventListener('shopify:block:select', event => {
        const id = event.detail && event.detail.blockId;
        if (this.cards.some(card => card.dataset.id === id)) this.choose(id);
      });
    }
    say(key, values = {}) {
      return Object.entries(values).reduce((s, [k, v]) => s.replaceAll(`{${k}}`, String(v)), this.messages[key] || '');
    }
    option(value) {
      const option = document.createElement('option');
      option.value = value; option.textContent = value; return option;
    }
    updateArtwork() {
      const kind = this.artworkSelect.selectedOptions[0]?.dataset.kind;
      const personalized = Boolean(kind && kind !== 'blank');
      this.$('[data-artwork-panel]').hidden = !personalized;
      this.querySelectorAll('[data-artwork-field]').forEach(field => {
        const active = field.dataset.artworkField === kind;
        field.hidden = !active;
        field.querySelectorAll('input, textarea, select').forEach(input => {
          input.disabled = !active;
          input.required = active && input.hasAttribute('data-artwork-required');
        });
      });
      this.$('[data-artwork-placement] select').disabled = !personalized;
    }
    price(cents) { return this.money.format(cents / 100); }
    cents(raw, allowZero = false) {
      if (!/^(0|[1-9]\d*)(\.\d{1,2})?$/.test(String(raw).trim())) return null;
      const [whole, fraction = ''] = String(raw).trim().split('.');
      const n = Number(whole) * 100 + Number(fraction.padEnd(2, '0'));
      return Number.isSafeInteger(n) && n <= 100000000 && (allowZero ? n >= 0 : n > 0) ? n : null;
    }
    readConfig(card) {
      const d = card.dataset;
      const min = Number(d.min), max = Number(d.max), step = Number(d.step);
      const quantitiesValid = [min, max, step].every(Number.isSafeInteger) && min >= 1 && max >= min && max <= 1000000 && step >= 1 && (max - min) % step === 0;
      const config = { min: quantitiesValid ? min : 1, max: quantitiesValid ? max : 1000, step: quantitiesValid ? step : 1, fee: this.cents(d.fee, true), tiers: [], valid: quantitiesValid };
      const rows = d.tiers.trim().split(/[\n;]+/).filter(row => row.trim());
      if (!rows.length || rows.length > 12) config.valid = false;
      for (const row of rows) {
        const pair = row.trim().split(':');
        const from = Number(pair[0]), amount = this.cents(pair[1]);
        if (pair.length !== 2 || !/^\d+$/.test(pair[0].trim()) || !Number.isSafeInteger(from) || amount === null || from < min || from > max || (from - min) % step !== 0) config.valid = false;
        config.tiers.push({ from, amount });
      }
      config.tiers.sort((a, b) => a.from - b.from);
      if (config.tiers[0]?.from !== min || config.fee === null) config.valid = false;
      config.tiers.forEach((tier, i) => {
        if (i > 0 && (tier.from === config.tiers[i - 1].from || tier.amount > config.tiers[i - 1].amount)) config.valid = false;
      });
      config.valid = config.valid && this.dataset.pricingEnabled === 'true';
      config.quantitiesValid = quantitiesValid;
      return config;
    }
    chooseOther() {
      this.otherMode = true;
      this.cards.forEach(item => item.hidden = true);
      this.otherProductField.hidden = false;
      this.otherProductInput.disabled = false;
      this.otherProductInput.required = true;
      this.sizeSelect.replaceChildren(this.option('Tell us below'));
      this.sizeSelect.disabled = true;
      this.$('[data-color-field]').hidden = true;
      this.colorSelect.disabled = true;
      this.config = { min: 1, max: 1000, step: 1, fee: 0, tiers: [], valid: false, quantitiesValid: false };
      for (const input of [this.range, this.number]) {
        input.min = this.config.min; input.max = this.config.max; input.step = this.config.step;
      }
      this.$('[data-moq]').hidden = true;
      this.$('[data-min-label]').textContent = this.integer.format(this.config.min);
      this.$('[data-max-label]').textContent = this.integer.format(this.config.max);
      this.$('[data-quantity-help]').textContent = 'Enter the quantity you are interested in. Final minimums and pricing will be confirmed with your quote.';
      this.$('[data-tiers-list]').replaceChildren();
      this.setQuantity(this.quantity || 100);
    }
    choose(id, saved) {
      this.otherMode = false;
      this.otherProductField.hidden = true;
      this.otherProductInput.disabled = true;
      this.otherProductInput.required = false;
      this.sizeSelect.disabled = false;
      const card = this.cards.find(item => item.dataset.id === id) || this.cards[0];
      this.card = card;
      this.cards.forEach(item => item.hidden = item !== card);
      this.familySelect.value = card.dataset.family;
      const sizes = [...new Set(this.cards.filter(item => item.dataset.family === card.dataset.family).map(item => Number(item.dataset.size)))].sort((a, b) => a - b);
      this.sizeSelect.replaceChildren(...sizes.map(size => this.option(`${size} oz`)));
      this.sizeSelect.value = `${card.dataset.size} oz`;
      this.config = this.readConfig(card);
      const preferredColor = saved?.color ?? saved?.style ?? this.colorSelect.value;
      this.colorSelect.replaceChildren(...Array.from(card.querySelector('[data-variant-source]').options).map(option => option.cloneNode(true)));
      const showColors = this.colorSelect.options.length > 1 || (this.colorSelect.options[0] && this.colorSelect.options[0].value !== 'Default Title');
      this.$('[data-color-field]').hidden = !showColors;
      this.colorSelect.disabled = !showColors;
      if (Array.from(this.colorSelect.options).some(option => option.value === preferredColor)) this.colorSelect.value = preferredColor;
      for (const input of [this.range, this.number]) {
        input.min = this.config.min; input.max = this.config.max; input.step = this.config.step;
      }
      this.$('[data-moq]').textContent = this.say('minimum', { quantity: this.integer.format(this.config.min) });
      this.$('[data-moq]').hidden = !this.config.quantitiesValid;
      this.$('[data-min-label]').textContent = this.integer.format(this.config.min);
      this.$('[data-max-label]').textContent = this.integer.format(this.config.max);
      this.$('[data-quantity-help]').textContent = this.say('range', { min: this.integer.format(this.config.min), max: this.integer.format(this.config.max), step: this.config.step });
      const list = this.$('[data-tiers-list]'); list.replaceChildren();
      if (this.config.valid) this.config.tiers.forEach(tier => {
        const button = document.createElement('button'); button.type = 'button'; button.className = 'esb__tier'; button.dataset.from = tier.from;
        const quantity = document.createElement('span'); quantity.textContent = this.integer.format(tier.from) + '+';
        const price = document.createElement('strong'); price.textContent = this.price(tier.amount);
        button.setAttribute('aria-label', this.say('select', { quantity: tier.from, price: this.price(tier.amount) }));
        button.append(quantity, price); button.addEventListener('click', () => this.setQuantity(tier.from)); list.append(button);
      });
      this.updateImage();
      this.setQuantity(saved?.quantity ?? this.quantity ?? this.config.min);
    }
    updateImage() {
      const img = this.card.querySelector('.esb__product-image');
      if (!img) return;
      if (!img.dataset.original) { img.dataset.original = img.src; img.dataset.originalSrcset = img.srcset; }
      const image = this.colorSelect.selectedOptions[0]?.dataset.image;
      if (image) { img.src = image; img.removeAttribute('srcset'); }
      else { img.src = img.dataset.original; img.srcset = img.dataset.originalSrcset; }
      img.alt = this.card.dataset.title + (this.colorSelect.disabled ? '' : ' — ' + this.colorSelect.value);
    }
    setQuantity(raw) {
      const { min, max, step } = this.config;
      const parsed = Number(raw);
      const finite = Number.isFinite(parsed) ? parsed : min;
      this.quantity = Math.min(max, Math.max(min, min + Math.round((finite - min) / step) * step));
      this.number.value = this.quantity; this.range.value = this.quantity;
      this.range.style.setProperty('--fill', `${max === min ? 100 : (this.quantity - min) / (max - min) * 100}%`);
      this.$('[data-quantity-output]').textContent = this.say('units', { quantity: this.integer.format(this.quantity) });
      this.$('[data-minus]').disabled = this.quantity === min; this.$('[data-plus]').disabled = this.quantity === max;
      this.render();
    }
    render() {
      const c = this.config, q = this.quantity;
      let unit = null, total = null;
      if (this.otherMode) {
        const requested = this.otherProductInput.value.trim() || this.otherProductLabel;
        const artwork = this.artworkSelect.value ? ` · ${this.artworkSelect.selectedOptions[0].textContent}` : '';
        this.$('[data-prices]').hidden = true;
        this.$('[data-quote-required]').hidden = false;
        this.$('[data-unit]').textContent = '—';
        this.$('[data-included]').textContent = 'Availability, customization options, minimum quantity, and bulk pricing will be confirmed with your quote.';
        this.$('[data-summary]').textContent = `${this.integer.format(q)} × ${requested} · Pricing by quote${artwork}`;
        this.$('[data-contact-product]').value = requested;
        this.$('[data-contact-handle]').value = '';
        this.$('[data-contact-variant]').value = '';
        this.$('[data-contact-unit]').value = this.say('quote');
        this.$('[data-contact-total]').value = this.say('quote');
        this.$('[data-contact-fee]').value = this.say('quote');
        this.$('[data-contact-included]').value = 'Custom product request — availability and pricing to be confirmed.';
        this.range.setAttribute('aria-valuetext', this.say('units', { quantity: q }));
        return;
      }
      this.$('[data-prices]').hidden = !c.valid;
      this.$('[data-quote-required]').hidden = c.valid;
      if (c.valid) {
        const tier = c.tiers.filter(t => q >= t.from).at(-1); unit = tier.amount; total = unit * q + c.fee;
        const next = c.tiers.find(t => t.from > q);
        const savings = (c.tiers[0].amount - unit) * q;
        this.$('[data-unit]').textContent = this.price(unit);
        this.$('[data-subtotal-label]').textContent = this.say('items', { quantity: this.integer.format(q), price: this.price(unit) });
        this.$('[data-subtotal]').textContent = this.price(unit * q);
        this.$('[data-setup]').textContent = this.price(c.fee);
        this.$('[data-total]').textContent = this.price(total);
        this.$('[data-saving]').textContent = savings ? this.say('save', { amount: this.price(savings) }) : this.say('base');
        this.$('[data-next]').textContent = next ? this.say('next', { quantity: this.integer.format(next.from - q), price: this.price(next.amount) }) : this.say('best');
        this.querySelectorAll('.esb__tier').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.from) === tier.from)));
        this.range.setAttribute('aria-valuetext', this.say('items', { quantity: q, price: this.price(unit) }));
      } else {
        this.$('[data-unit]').textContent = '—';
        this.range.setAttribute('aria-valuetext', this.say('units', { quantity: q }));
      }
      this.$('[data-included]').textContent = this.card.dataset.inclusions;
      const color = this.colorSelect.disabled ? '' : ` / ${this.colorSelect.value}`;
      const artwork = this.artworkSelect.value ? ` · ${this.artworkSelect.selectedOptions[0].textContent}` : '';
      this.$('[data-summary]').textContent = this.say('summary', { quantity: this.integer.format(q), product: this.card.dataset.title + color, total: total === null ? this.say('quote') : this.price(total) + ' USD' }) + artwork;
      this.$('[data-contact-product]').value = this.card.dataset.title;
      this.$('[data-contact-handle]').value = this.card.dataset.handle;
      this.$('[data-contact-variant]').value = this.colorSelect.selectedOptions[0]?.dataset.variantId || '';
      this.$('[data-contact-unit]').value = unit === null ? this.say('quote') : (unit / 100).toFixed(2);
      this.$('[data-contact-total]').value = total === null ? this.say('quote') : (total / 100).toFixed(2);
      this.$('[data-contact-fee]').value = c.valid ? (c.fee / 100).toFixed(2) : this.say('quote');
      this.$('[data-contact-included]').value = this.card.dataset.inclusions;
      try { sessionStorage.setItem(this.storageKey, JSON.stringify({ product: this.card.dataset.id, quantity: q, color: this.colorSelect.value })); } catch (_) {}
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
